import { auth,db } from "./index";

export const signIn = async ({ email, password }) => {
  return await auth.signInWithEmailAndPassword(email, password);
};

export const getIdToken = async (user) => {
  return await user.getIdToken();
};

export const getCurrentUserToken = async() => {
 if(auth.currentUser){
  let idToken = await auth.currentUser.getIdToken(true);
  return idToken
 }else{
     return null;
 }
}

export const getUserInformation =async(user)=>{
return await db.collection("users").where("email", "==", user.email).get();
}

export const getProductInformation =async()=>{
  return await db.collection("products").where("id", "==", 'KkVsqedE1otWbXBRfSQs').get();
  }
  